import type { FormField } from '@cli-types/core-engine/schema.js'
import { formFieldToZodType } from '@core-engine/schema/type-mappers/zod/form-field-to-zod-type.js'

export function buildZodFields(fields: FormField[]): string {
  return fields
    .filter((f) => f.name)
    .map((f) => `  ${f.name}: ${formFieldToZodType(f)}`)
    .join(',\n')
}
